/**
 *
 * Manage autocomplete search
 *
 * @author: David Pocina <dpocina[at]zerogrey[dot]com>
 *
 * DISCLAIMER:
 *   I just re-wrote this.
 *   I'm not sure about what half of the input fields are
 *   supposed to do or why are we spliting the product name
 *   in " - "
 *
 */
(function ( $ ) { "use strict";

	/**
	 * @selector data-zg-role="product-finder-elastic" The plugin start if there is the selector in the dom when the page load
	 */

	var toggle                	= '[data-zg-role="product-finder-elastic"]';
	var toggle_form             = '[data-zg-role="product-finder-elastic-form"]';
	var toggle_search_input   	= '[data-zg-role="search-elastic-input"]';
	var toggle_search_type    	= '[data-zg-role="search-type"]';
	var toggle_search_id      	= '[data-zg-role="search-id"]';
	var toggle_product_id     	= '[data-zg-role="search-product_id"]';
	var toggle_product_name   	= '[data-zg-role="search-product_name"]';
	var toggle_typeahead_ul   	= '[data-zg-role="typeahead-ul-elastic"]';
	var toggle_opacity_search 	= '[data-zg-role="opacity-search"]';
	var toggle_btn_search 		= '[data-zg-role="btn-elastic-search"]';
	var toggle_btn_mobile_search = '#typeahead-search-button';
	var toggle_search_container = '#searchElasticContainer';
	var toggle_erase_btn      	= '#typeahead-erase-button';
	var toggle_close_btn		= '[data-zg-role="btn-close-elastic-search"]';
	var toggle_mobile_button = '[data-toggle="elastic-toggle"]';

	//Code to simulate option selected: A is layoutA, B is layoutB, C is layoutC and D is layoutD
	//var layoutDesktopTemplate = 'D';

	//Code to simulate option selected for mobile: suggestions is A, categories is B, brands is C
	//var mobileAutocompleteSelected = 'categories';

	//code for mobile layout that show logo
	//var layoutMobileTemplate = true;

	var DEFAULTS = {
		layoutDesktopTemplate: 'A',
		mobileAutocompleteSelected: 'A',
		layoutMobileTemplate: 'A',
		suggestionsDesktopItems: 0,
		categoriesDesktopItems: 0,
		brandsDesktopItems: 0,
	};

	var ZG_Search = function ( element, config ) {
		var self = this;

		this.init = function ( element, config ) {
			var $element       = $(element);
			self.defaultOptions = _.clone( DEFAULTS );
			self.$element      = $element;
			self.config        = $.extend( self.defaultOptions, config, self.$element.data('config') || {} );
			self.$eventBus     = $(document);

			self.$toggle_form             = $element.find( toggle_form );
			self.$search_input 			  = $element.find( toggle_search_input );
			self.$typeahead_ul 			  = $element.find( toggle_typeahead_ul );
			self.$toggle_erase_btn 		  = $element.find( toggle_erase_btn );
			self.$toggle_btn_search       = $element.find( toggle_btn_search );
			self.toggle_btn_mobile_search = $element.find( toggle_btn_mobile_search );
			self.$toggle_search_container = $element.find( toggle_search_container );
			self.$toggle_opacity_search   = $element.find( toggle_opacity_search );
			self.$toggle_close_btn		  = $element.find( toggle_close_btn );
			self.$toggle_mobile_button		= $(document).find( toggle_mobile_button );

			self.$toggle_form.on("submit", self.searchProducts);
			if( self.config.layoutMobileTemplate === 'D' ){
				self.$element.addClass('mobile-show-logo');
			}
			self.__setEventHandlers();
			self.startTypeAhead();
		};

		this.selectElasticSearch = function () {
			var val = this.$menu.find('.active').attr('data-value')
			var val2 = val.replace(/<em>/gi, '');
			var valFinal = val2.replace(/<\/em>/gi, '');
			if (typeof val !== 'undefined') {
				this.$element
					.val(this.updater(valFinal))
					.change();

				if (this.ajax && this.ajax.loadProductPageBy != null){
					var id = this.$menu.find('.active').attr('data-id');
					var type = this.$menu.find('.active').attr('data-type');
					if( id > 0 ){
						this.$element.attr('data-id',id);
						this.$element.attr('data-type',type);

						if(type == 'product'){
							this.$element.attr('data-value',this.$menu.find('.active').attr('data-value'));
						}
					} else {
						this.$element.val(valFinal);
					}
					this.$element.closest( toggle_form ).submit();
				}
			}
			return this.hide();
		};

		this.setHeightContainer = function() {
			let res = $('[data-zg-role="elastic-right-column"]').outerHeight() + 'px';
			if ( $('[data-zg-role="elastic-right-column"]').outerHeight() > 0 ) {
				self.$typeahead_ul.css('min-height', res);
			} else {
				self.$typeahead_ul.css('min-height', '100px');
			}
		}

		this.showElasticSearch = function() {
			this.$menu.show();
			$('.truncate').succinct( { size: 90 } );//truncate the description
			$('.truncate-full-screen').succinct( { size: 160 } );//truncate the description full screen
			self.setHeightContainer();
			this.shown = true;
			return this;
		};

		this.hideElasticSearch = function () {
			this.$menu.hide();
			this.shown = false;
			self.$toggle_opacity_search.removeClass('opacity-search');
			if( self.config.layoutMobileTemplate === 'A' ) {
				self.$typeahead_ul.removeClass('height-100vh');
			}
			this.$menu.find('#elastic_mobile_search_button').remove();
			return this;
		};

		this.setRightContent = function (i, element, itemsValue, name, translation) {
			let container = i.find(`ul[data-elastic='${name}']`);
			if (element == null || element.length === 0) {
				//container.attr('style', 'display:none;');
				container.removeClass( 'visible-md visible-lg' ).addClass('hidden-md hidden-lg');
			} else if (element.length !== 0 ) {
				if( itemsValue === 0 ){
					container.removeClass( 'visible-md visible-lg' ).addClass('hidden-md hidden-lg');
				}

				let cssClass = 'heading-elastic';

				if ( self.config.layoutMobileTemplate === 'A' ) {
					cssClass = 'heading-elastic heading-hidden';
				}

				container.append('<p class="' + cssClass + '">' + JS_TRANSLATIONS[translation] + '</p>');

				for (let index = 0; index < element.length; index++){

					let liElement = `<li data-elastic="${name}-item"></li>`;

					if( index >= itemsValue){
						if (index < 2) {
							liElement = `<li class="visible-xs visible-sm" data-elastic="${name}-item"></li>`;
						} else {
							liElement = `<li class="hidden" data-elastic="${name}-item"></li>`;
						}
					} else if ( index >= 2 ) {
						liElement = `<li class="hidden-xs hidden-sm" data-elastic="${name}-item"></li>`;
					}


					container.append( liElement );
					let liresult = i.find(`li[data-elastic='${name}-item']`);
					liresult.eq(index).html(element[index]);
					liresult.eq(index).attr('data-value', element[index]);
					liresult.eq(index).attr('data-id', 0);
					liresult.eq(index).attr('data-type', name);
				}
			}
		};

		this.renderElasticSearch = function ( items ) {
			const that = this,
				suggestionsArr =[];
			let suggestions, categories, brands, resultName, resultDesc,
				resultImg, resultPrice, resultCurrency, resultId, resultType, resultUrl,
				allCharacteristicNotPresent = false, paddingRow = '', allItems = items;

			items = $(items).map(function (i, item) {
				resultName = item.product_data.name;
				resultDesc = item.product_data.short_description;
				resultImg = item.product_data.images.small;
				resultPrice = item.product_data.price.sell;
				resultCurrency = item.product_data.price.currency_symbol;
				resultId = item.product_id;
				resultType = item.type;
				resultUrl = makeUrl( { module: 'eshop', manager: 'product', pid: resultId } );
				suggestions = item.suggestions;
				categories = item.categories;
				brands = item.brands;
				let highlights = item.highlight;
				if ( that.ajax && that.ajax.displayField!=null && that.ajax.loadProductPageBy!=null ) {
					i = $(that.options.item).attr('data-value', item.product_data.name);
					i.find("span[data-elastic='name']").html(resultName);
					i.find("div[data-elastic='desc']").html(resultDesc);
					if (highlights != null && Array.isArray(highlights)) {
						highlights.forEach((param)=>{
							if (param.field === '>names<'){
								i.find("span[data-elastic='name']").html(param.values);
							}
							if (param.field === '>short_description<') {
								i.find("div[data-elastic='desc']").html(param.values);
							}
						});
					}
					i.attr('data-id', resultId);
					i.attr('data-type', resultType);
					i.find("a").attr('href', resultUrl);
					i.find("img").attr('src', resultImg);
					i.find("img").attr('alt', resultName);
					i.find("span[data-elastic='price']").html(resultPrice);
					i.find("span[data-elastic='currency']").html(resultCurrency);

					//if (suggestions == null || suggestions.length === 0 || self.config.suggestionsDesktopItems === 0) {
					if (suggestions == null || suggestions.length === 0) {
						suggestionsArr.length = 0;
					} else {
						for (let sug in suggestions) {
							suggestionsArr.push(suggestions[sug]);
							if (suggestionsArr.length > 10) {
								break;
							}
						}
					}

					self.setRightContent( i, suggestionsArr, self.config.suggestionsDesktopItems,'suggestions', 'Suggestions' );

					self.setRightContent(i, categories, self.config.categoriesDesktopItems,'categories', 'Categories');

					self.setRightContent(i, brands, self.config.brandsDesktopItems,'brands', 'Brands');

					if( (suggestions === null || suggestions === undefined ||suggestions.length === 0 || self.config.suggestionsDesktopItems === 0) &&
						(categories === null || categories === undefined || categories.length === 0 || self.config.categoriesDesktopItems === 0) &&
						(brands === null || brands === undefined || brands.length === 0 || self.config.brandsDesktopItems === 0) ) {
						self.$typeahead_ul.find('[data-zg-role="elastic-right-column"]').attr('style', 'display:none;');
					}


				} else {
					i = $(that.options.item).attr('data-value', item);
					i.find( 'a' ).html( that.highlighter( item )) ;
				}
				return i[0];
			});

			items.first().addClass( 'active' );

			if( self.config.layoutDesktopTemplate === 'C' ) {
				paddingRow = 'padding-sm ';
			} else if ( self.config.layoutDesktopTemplate === 'B' ) {
				paddingRow = 'custom-padding ';
			}

			this.$menu.html( `<div class="row margin-none row-custom-style ${paddingRow}relative" data-zg-role="elastic-row"></div>` );

			this.$menu.find( '[data-zg-role="elastic-row"]' ).html( items );

			if( self.config.layoutDesktopTemplate === 'D' ) {
				this.$menu.find( '[data-zg-role="elastic-row"]' ).prepend(`<p class="visible-md visible-lg text-left full-width related-product-heading text-capitalize">${JS_TRANSLATIONS['related_products']}</p>`);
			}

			//Hide right column when data (suggestions, categories, brands) is not present, so we show products only
			if( (allItems[0].suggestions === null || allItems[0].suggestions.length === 0 || self.config.suggestionsDesktopItems === 0) &&
				(allItems[0].categories === null || allItems[0].categories.length === 0 || self.config.categoriesDesktopItems === 0) &&
				(allItems[0].brands === null || allItems[0].brands.length === 0 || self.config.brandsDesktopItems === 0) ) {
				//self.$typeahead_ul.find('[data-zg-role="elastic-right-column"]').attr('style', 'display:none;');
				let rightColumn = self.$typeahead_ul.find('[data-zg-role="elastic-right-column"]');
				if( self.config.mobileAutocompleteSelected !== 0 ){
					rightColumn.addClass( 'visible-xs visible-sm hidden-md hidden-lg' );
				} else {
					rightColumn.addClass( 'hidden' );
				}
				self.$typeahead_ul.find( '[data-zg-role="elastic-row"]' ).attr('style', 'width:100%;');
				self.$typeahead_ul.find( '.result-product-container' ).addClass('products-only');
				//allCharacteristicNotPresent = true;
				if ( self.config.layoutDesktopTemplate === 'D' ) {
					self.$typeahead_ul.find( '[data-zg-role="elastic-row"]' ).addClass('no-right-column');
				}
			}

			if( self.config.mobileAutocompleteSelected === '0' ){
				self.$typeahead_ul.find('[data-zg-role="elastic-right-column"]').addClass( 'hidden-xs hidden-sm' );
			}

			function  addProductHeading() {
				if ( self.config.layoutMobileTemplate === 'B' ) {
					$( '.result-product-container' ).first().append(`<p class="visible-xs visible-sm order-1 heading-elastic">${JS_TRANSLATIONS['Products']}</p>`);
				}
			}

			//if ( allCharacteristicNotPresent === false){
				switch ( self.config.mobileAutocompleteSelected ) {
					case 'A':
						//if( allItems[0].suggestions == null || allItems[0].suggestions.length === 0 || self.config.suggestionsDesktopItems === 0) {
						if( allItems[0].suggestions == null || allItems[0].suggestions.length === 0 ) {
							self.$typeahead_ul.find( '.result-product-container' ).addClass('products-only');
						} else {
							addProductHeading();
						}
						break;
					case 'B':
						//if( allItems[0].categories == null || allItems[0].categories.length === 0 || self.config.categoriesDesktopItems === 0) {
						if( allItems[0].categories == null || allItems[0].categories.length === 0) {
							self.$typeahead_ul.find( '.result-product-container' ).addClass('products-only');
						} else {
							addProductHeading();
						}
						break;
					case 'C':
						//if( allItems[0].brands == null || allItems[0].brands.length === 0 || self.config.brandsDesktopItems === 0) {
						if( allItems[0].brands == null || allItems[0].brands.length === 0) {
							self.$typeahead_ul.find( '.result-product-container' ).addClass('products-only');
						} else {
							addProductHeading();
						}
						break;
				}

			//}

			//Clone send button because it was impossible to set it with css in the desired position in mobile
			self.toggle_btn_mobile_search.clone().appendTo( self.$typeahead_ul ).attr('id', 'elastic_mobile_search_button').addClass('visible-xs visible-sm').removeClass('visible-md visible-lg');

			this.$menu.find( '#elastic_mobile_search_button' ).text( JS_TRANSLATIONS['elastic.search_button'] + ' "' + self.$search_input.val() +'"' );

			this.$menu.removeClass( 'loading show' );

			return this;
		};

		this.keyboardNavigation = function ( key, $menu ){
			var selectedElem = false;
			var $elasticRightItems = $menu.find( '[data-zg-role="elastic-right-column"] li' ),
				$elasticItems = $menu.find( '.elastic-item-container' ), currentIndex,
				$selectedBox = $menu.find( '.selected' );

			for (var i = 0, n = $elasticRightItems.length; i < n; i++ ) {
				if( $elasticRightItems[i].classList.contains('selected') ) {
					$selectedBox = $( $elasticRightItems[i] );
					selectedElem = true;
					currentIndex = i;
					break;
				}
			}

			if ($selectedBox.length !== 0) {
				selectedElem = true
			}
			$selectedBox.removeClass('selected');

			switch(key){
				case 40: // down arrow
					if( !selectedElem || ($selectedBox.hasClass('elastic-item-container') === false && ( $elasticRightItems.length === (currentIndex + 1) ) ) ){
						if( !$selectedBox || $selectedBox.length === 0 || ( $elasticRightItems.length === (currentIndex + 1) )  ) {
							$elasticRightItems.first().addClass('selected')
						}else{
							$elasticItems.first().addClass('selected')
						}
					}else{
						if($selectedBox.hasClass('elastic-item-container')) {
							if($selectedBox.parents('.result-product-container').is(':last-child')){
								$elasticItems.first().addClass('selected')
							}else {
								$selectedBox.parents('.result-product-container').next().find('.elastic-item-container').addClass('selected')
							}
						}else{
							$elasticRightItems[currentIndex + 1].classList.add('selected');
						}
					}
					break
				case 38: // up arrow
					if( !selectedElem || ($selectedBox.hasClass('elastic-item-container') === false && ( currentIndex === 0 ) ) ){
						if( !$selectedBox || ( currentIndex === 0 ) || $selectedBox.length === 0  ) {
							$elasticRightItems.last().addClass('selected')
						}else{
							$elasticItems.last().addClass('selected')
						}

					}else{
						if($selectedBox.hasClass('elastic-item-container')) {
							if($selectedBox.parents('.result-product-container').is(':first-child')){
								$elasticItems.last().addClass('selected')
							}else {
								$selectedBox.parents('.result-product-container').prev().find('.elastic-item-container').addClass('selected')
							}
						}else{
							$elasticRightItems[currentIndex - 1].classList.add('selected');
						}
					}
					break
				case 37: //left arrow
					if($selectedBox.hasClass('elastic-item-container')){
						$elasticRightItems.first().addClass('selected')
					}else{
						$elasticItems.first().addClass('selected')
					}
					break
				case 39: //right arrow
					if($selectedBox.hasClass('elastic-item-container')){
						$elasticRightItems.first().addClass('selected')
					}else{
						$elasticItems.first().addClass('selected')
					}
					break
			}
		};

		this.keyupElasticSearch = function ( e ){

			switch(e.keyCode) {

				case 16: // shift
				case 17: // ctrl
				case 18: // alt
					break
				case 40: // down arrow
				case 39: //left arrow
				case 38: // up arrow
				case 37: //left arrow
					self.keyboardNavigation(e.keyCode,this.$menu)
					break

				case 9: // tab
				case 13: // enter
					if (!this.shown) return
					var $selectedBox = this.$menu.find('.selected')
					if ($selectedBox.length !== 0 && $selectedBox.hasClass('elastic-item-container')) {
						$selectedBox.trigger('click')
					}else if($selectedBox.length !== 0){
						//$("#product-finder-elastic").find('[data-zg-role="search-elastic-input"]').val($selectedBox.text());
						$('[data-zg-role="product-finder-elastic"]').find('[data-zg-role="search-elastic-input"]').val($selectedBox.text());

						//$("#product-finder-elastic").submit();
						$('[data-zg-role="product-finder-elastic"]').submit();
					}else{
						//$("#product-finder-elastic").submit();
						$('[data-zg-role="product-finder-elastic"]').submit();
					}
					break

				case 27: // escape
					if (!this.shown) return
					this.hide()
					break

				default:
					if( this.$element.val() != '' ){
						self.$toggle_erase_btn.removeClass( 'hidden' );
					}
					else {
						self.$toggle_erase_btn.addClass( 'hidden' );
					}
					this.ajax ? this.ajaxLookup() : this.lookup()
			}

			e.stopPropagation()
			e.preventDefault()
		};

		this.blurElasticSearch = function () {
			this.focused = false
		};

		this.clickElasticSearch = function ( e ) {
			if (e.target.tagName != "LI" && e.target.tagName != 'EM'){
				return;
			}
			this.select();
			this.$element.focus();
		};
		/*
		* set right content to show mobile option
		* */
		this.setRightColumnStructure = function( selected ) {
			var rightContent;

			/*I have played with the visible and hidden class in BT3 and was the only way to show or hide.
			  It is a bit confusing, but I want to use custom classes when necessary only.
			 */
			switch( selected ){
				case 'A':
					rightContent = `<ul data-elastic="suggestions" class="visible-xs visible-sm visible-md visible-lg"></ul><ul data-elastic="categories" class="hidden-xs hidden-sm visible-md visible-lg"></ul><ul data-elastic="brands" class="hidden-xs hidden-sm visible-md visible-lg"></ul>`;
					break;
				case 'B':
					rightContent = `<ul data-elastic="suggestions" class="hidden-xs hidden-sm visible-md visible-lg"></ul><ul data-elastic="categories" class="visible-xs visible-sm visible-md visible-lg"></ul><ul data-elastic="brands" class="hidden-xs hidden-sm visible-md visible-lg"></ul>`;
					break;
				case 'C':
					rightContent = `<ul data-elastic="suggestions" class="hidden-xs hidden-sm visible-md visible-lg"></ul><ul data-elastic="categories" class="hidden-xs hidden-sm visible-md visible-lg"></ul><ul data-elastic="brands" class="visible-xs visible-sm visible-md visible-lg"></ul>`;
					break;
				case '0':
					rightContent = `<ul data-elastic="suggestions" class="visible-md visible-lg"></ul><ul data-elastic="categories" class="visible-md visible-lg"></ul><ul data-elastic="brands" class="visible-md visible-lg"></ul>`;
					break;
				default:
					rightContent = `<ul data-elastic="suggestions"></ul><ul data-elastic="categories"></ul><ul data-elastic="brands"></ul>`;
			}

			return rightContent;

		};

		this.startTypeAhead = function() {
			const url = window.makeUrl({module: 'eshop', action: 'autoComplete'});

			const rightContent = this.setRightColumnStructure( self.config.mobileAutocompleteSelected );

			const hideDescriptionMobileLayoutB = (self.config.layoutMobileTemplate === 'B') ? 'hidden-xs hidden-sm ' : '';

			let structureA = `<div class="result-product-container line-bottom padding-a col-xs-12 padding-none">
								<a href="" data-elastic="link" class="elastic-item-link">
									<div class="elastic-item-container">
										<div class="elastic-img-container col-xs-1 col-md-2">
											<img class="img-responsive elastic-img" src="" alt="">
										</div>
										<div class="col-xs-11 col-md-10 text-left" data-zg-role="elastic-data-container">
											<p class="margin-bottom-xs mw-85"><span data-elastic="name"></span></p>
											<div class="${hideDescriptionMobileLayoutB}elastic-item-desc truncate" data-elastic="desc"></div>
											<div class="elastic-item-price">
												<span data-elastic="currency"></span><span data-elastic="price"></span>
											</div>
										</div>
									</div>
								</a>
								<div id="right-column" data-zg-role="elastic-right-column">${rightContent}</div>
							</div>`;

			let structureB = `<div class="result-product-container line-bottom-mobile col-xs-12 col-md-6 padding-none">
									<a href="" data-elastic="link" class="elastic-item-link">
										<div class="elastic-item-container line-bottom-mobile">
											<div class="elastic-img-container col-xs-1 col-md-4">
												<img class="img-responsive" src="" alt="">
											</div>
											<div class="col-xs-11 col-md-8 text-left" data-zg-role="elastic-data-container">
												<p class="margin-bottom-xs"><span data-elastic="name"></span></p>
												<div class="${hideDescriptionMobileLayoutB}elastic-item-desc truncate margin-bottom-sm" data-elastic="desc"></div>
												<div class="price"><span data-elastic="currency"></span><span data-elastic="price"></span></div>
											</div>
										</div>
									</a>
									<div id="right-column" data-zg-role="elastic-right-column">${rightContent}</div>
								</div>`;

			let structureC = `<div class="result-product-container line-bottom-mobile col-xs-12 col-md-4 padding-none">
									<a href="" data-elastic="link" class="elastic-item-link">
										<div class="elastic-item-container elastic-item-container-block line-bottom-mobile">
											<div class="elastic-img-container col-xs-1 col-md-12">
												<img class="img-responsive align-center img-elastic-fixed" src="" alt="">
											</div>
											<div class="col-xs-11 col-md-12 text-center" data-zg-role="elastic-data-container">
												<p><span data-elastic="name"></span></p>
												<div class="${hideDescriptionMobileLayoutB}hidden-md hidden-lg elastic-item-desc truncate margin-bottom-sm" data-elastic="desc"></div>
												<div class="price"><span data-elastic="currency"></span><span data-elastic="price"></span></div>
											</div>
										</div>
									</a>
									<div id="right-column" data-zg-role="elastic-right-column">${rightContent}</div>
								</div>`;

			let structureD = `<div class="result-product-container line-bottom-mobile col-12 col-md-4">
									<a href="" data-elastic="link" class="elastic-item-link">
										<div class="elastic-item-container line-bottom-mobile desktop">
											<div class="col-xs-10 col-md-12 margin-bottom-lg text-center" data-zg-role="elastic-data-container">
												<p class="mb-0 mb-lg-2 margin-bottom-xs"><span data-elastic="name"></span></p>
												<div class="price"><span data-elastic="currency"></span><span data-elastic="price"></span></div>
											</div>
											<div class="elastic-img-container col-xs-2 col-md-12 margin-bottom-lg text-center">
												<img class="img-fluid image-full-screen" src="" alt="">
											</div>
											<div class="col-xs-12">
												<div class="${hideDescriptionMobileLayoutB}elastic-item-desc truncate-full-screen margin-bottom-md text-center" data-elastic="desc"></div>
											</div>
										</div>
										<div class="elastic-item-container line-bottom-mobile mobile">
											<div class="elastic-img-container col-xs-1 col-md-4">
												<img class="img-responsive" src="" alt="">
											</div>
											<div class="col-xs-11 col-md-8 text-left" data-zg-role="elastic-data-container">
												<p class="ellipsis margin-bottom-xs"><span data-elastic="name"></span></p>
												<div class="${hideDescriptionMobileLayoutB}elastic-item-desc truncate margin-bottom-sm" data-elastic="desc"></div>
												<div class="price"><span data-elastic="currency"></span><span data-elastic="price"></span></div>
											</div>
										</div>
									</a>
									<div id="right-column" data-zg-role="elastic-right-column">${rightContent}</div>
								</div>`;

			let structure, itemsShow = 6;

			switch ( self.config.layoutDesktopTemplate ) {
				case 'A':
					structure = structureA;
					itemsShow = 5;
					break;
				case 'B':
					structure = structureB;
					break;
				case 'C':
					structure = structureC;
					break;
				case 'D':
					structure = structureD;
					itemsShow = 3;
					break;
			}

			self.$search_input.typeahead({
				ajax: {
					url: url,
					preDispatch: function (query) {
						self.$toggle_opacity_search.addClass('opacity-search');
						self.$typeahead_ul[0].style.display = "block";
						self.$typeahead_ul.addClass( 'loading' );
						return {
							action: 'autoComplete',
							key: query,
							limit: 6,
							orderBy : 'name',
							sortOrder : 'ASC',
							maxCharsForProduct: 70
						};
					},
					dType : 'type',
					displayField : 'value',
					loadProductPageBy : 'id'
				},
				sorter : 'none',
				items  : itemsShow,
				menu: self.$typeahead_ul,
				select: self.selectElasticSearch,
				show: self.showElasticSearch,
				hide: self.hideElasticSearch,
				render: self.renderElasticSearch,
				arrowNavigation: self.arrowNavigation,
				keyup: self.keyupElasticSearch,
				blur: self.blurElasticSearch,
				click: self.clickElasticSearch,
				item: structure
			});
		}

		this.searchProducts = function() {
			var productName = self.$search_input.val();
			if ( !productName || productName==="" ) return false;

			var type = self.$search_input.data('type') || "";
			var id   = self.$search_input.data('id')   || "";

			// we are getting here only once. we don't need to add this to the "self" object
			self.$toggle_form.find( toggle_search_type ).val( type );
			self.$toggle_form.find( toggle_search_id ).val( id );
			self.$toggle_form.find( toggle_product_id ).val( id );
			self.$toggle_form.find( toggle_product_name ).val( productName.split(" - ")[0] );

			self.$toggle_form.find(".characteristic-key").val(productName);
		}

		this.__setEventHandlers = function () {
			var that = this;

			self.$toggle_opacity_search.click( function(){
				self.$typeahead_ul.hide();
				self.$toggle_opacity_search.removeClass('opacity-search');
				//self.$toggle_erase_btn.addClass( 'hidden' );
				self.$search_input.removeClass( 'search-active' );
			});

			/*
			self.$toggle_opacity_search.click( function(){
				self.$typeahead_ul.hide();
				self.$toggle_opacity_search.removeClass('opacity-search');
				//this.removeOverflow();
			});
			*/

			self.$search_input.click(function(){
				self.$typeahead_ul.find('.selected').removeClass('selected');
			});
			// Erase query and close input
			self.$toggle_erase_btn.click( function(){
				self.$typeahead_ul.hide();
				self.$search_input[0].value = "";
				self.$toggle_opacity_search.removeClass('opacity-search');
				self.$toggle_erase_btn.addClass( 'hidden' );
				self.$search_input.removeClass( 'search-active' );
			});

			

			self.$toggle_close_btn.click( function(){
				self.$toggle_search_container.addClass('hidden');
				self.$toggle_btn_search.addClass('show');
				self.$toggle_btn_search.removeClass('hidden');
				self.$toggle_opacity_search.removeClass('opacity-search');
			});

			self.$toggle_mobile_button.click ( function( e ){
				e.preventDefault();
				self.$element.toggleClass( 'd-flex' );
				self.$toggle_mobile_button.addClass( 'hidden' );
			});

			if( self.config.layoutDesktopTemplate === 'D' ) {
				// Toggle the search input
				self.$toggle_btn_search.click( function(){
					self.$toggle_opacity_search.addClass('opacity-search');
					self.$toggle_btn_search.addClass('show');
					self.$toggle_btn_search.removeClass('hidden');
					if( self.$toggle_search_container.hasClass( 'hidden' ) ){
						self.$toggle_search_container.removeClass( 'hidden' );
						self.$toggle_search_container.addClass( 'show' );
						self.$search_input.focus();
					}
					else {
						self.$toggle_search_container.addClass( 'hidden' );
						self.$toggle_search_container.removeClass( 'show' );
					}
				});
			}

			
			self.$toggle_opacity_search.click( function(){
				//self.$toggle_search_container.addClass('hidden');
				self.$toggle_btn_search.addClass('show');
				//self.$toggle_btn_search.removeClass('hidden');
				self.$toggle_opacity_search.removeClass('opacity-search');
			});
			
			var resizeHeight = _.debounce( function() { self.setHeightContainer() }, 100);
			$( window ).on( "resize", resizeHeight );

		}

		this.init( element, config );
	};

	$.fn.ZG_search = function ( config ) {
		return this.each( function () {
			var $this = $(this);
			var data = $this.data('zgSearch');
			if (!data) {
				$this.data('zgSearch', (data = new ZG_Search( this, config )) );
			}
		});
	};

	// Initilize Script
	$(toggle).ZG_search( window.ZG_CONFIG );
})( jQuery );